import React, { useState, useEffect } from 'react';
import './pages-css/Tour.css'; // We'll use normal CSS
import { url } from '../../constants/url';


const GuidedTour = ({ steps = [], onFinish, currentStep, setCurrentStep, firstletter, toggleDropdown, checkAuth }) => {
    const [highlightStyle, setHighlightStyle] = useState({});

    const updateTour = async () => {
        try {
            const response = await fetch(`${url}/updatetour`, {
                method: "PUT",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                }
            })
            if(response.status === 200){
                checkAuth()
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (!steps || steps.length === 0) return;

        const step = steps[currentStep];
        if (!step) return;

        const element = document.querySelector(step.target);
        if (element) {
            const rect = element.getBoundingClientRect();
            setHighlightStyle({
                top: rect.top + window.scrollY - 5 + 'px',
                left: rect.left + window.scrollX - 5 + 'px',
                width: rect.width + 10 + 'px',
                height: rect.height + 10 + 'px',
            });

            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [currentStep, steps]);

    const nextStep = () => {
        setCurrentStep(-1); 
        onFinish?.();
        updateTour()
    };

    if (!steps || steps.length === 0 || currentStep === -1) return null;

    const step = steps[currentStep];

    return (
        <div className='tour-overlay'>
            <div className="tour_content_wrap">
                <div className="tour-highlight" style={highlightStyle}>
                    <div onClick={toggleDropdown}><h4>{firstletter}</h4></div>

                </div>
                <div className="bezier-container rotated">
                    <svg width="300" height="170">
                        <path
                            d="M20 20 C110 150, 180 10, 210 140"
                            stroke="black"
                            strokeWidth="1"
                            fill="transparent"
                            className="bezier-path"
                        />
                    </svg>
                </div>
                <div
                    className={`tour-tooltip tour-${step.placement}`}
                    style={{
                        top: highlightStyle.top
                            ? parseFloat(highlightStyle.top) + parseFloat(highlightStyle.height) + 10 + 'px'
                            : 0,
                        left: highlightStyle.left || 0,
                    }}
                >
                    <p>{step.content}</p>
                    <button onClick={nextStep} className="tour-next-btn">Got it</button>
                </div>
            </div>
        </div>
    );
};




export default GuidedTour;
